import { useNextgenRouter } from '@nextgen-web-framework/all';
import { ErrorCard, Errors } from '@commerce-webcomponents/ui';
import { PageContentErrorHandlerProps } from './types/propsTypes';
import NotFound from 'components/NotFound/NotFound';

const PageContentErrorHandler = ({ children, content, notFoundData = {} }: PageContentErrorHandlerProps) => {
  const router = useNextgenRouter();
  if (content?.hasError) {
    return <ErrorCard type={Errors.General} onActionClick={() => router.push('/')} />;
  }
  if (content?.notFound) {
    return <NotFound data={notFoundData} />;
  }
  return children;
};

export default PageContentErrorHandler;
